export const MyRoutes = {
	Local: 'http://localhost:1100',
	LocalLive: 'http://localhost:1110',
	Cypress: 'http://localhost:1120',
	Test: 'https://my.stage.agilox.net',
	Beta: 'https://my.beta.agilox.net',
	Live: 'https://my.agilox.net',
	Stage: 'https://my.stage.agilox.net',
} as const;
